<template>
	<div>
		<div id="parent-sign">
			<div @click="hasClicked = true" @touchstart="hasClicked = true">
				<vueSignature
				:default-url="bgData"
				v-if="refresh"
				id="sign-inp"
				class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-gray-400 focus:border-gray-400 block w-full p-2.5"
				ref="signatureInp"
				:h="option.height"
				:w="option.width"
				:sigOption="option"
				></vueSignature> 
			</div>
			<button class="mt-2 font-light" @click="init">
				<i class="mr-1 fas fa-redo"></i> {{$t('composants.sav-draw-input.recommencer')}}
			</button>
		</div>
	</div>
</template>

<script>
import vueSignature from "vue-signature"
import apiUploadService from '@/services/apiUpload.service'

import eventHub from '@/eventHub'

export default {
	name: "app",
	components:{
		vueSignature
	},
	props: {
		bg: {},
		id: {required: true}
	},
	watch: {
		bg: function(value) {
			this.bgData = value
		}
	},
	data() {
		return {
			option:{
				penColor:"rgb(0, 0, 0)",
				height: '100%',
				width: '100%'
			},
			refresh: true,
			bgData: null,
			hasClicked: false
		};
	},
	methods:{
		async save(type) {
			if (this.hasClicked) {
				var _this = this;
				var png = _this.$refs.signatureInp.save('image/jpeg')
	
				// Convert draw to file
				let file = null
				if (type == 'img') {
					const dataToBlob = async (imageData) => {
						return await (await fetch(imageData)).blob();
					};
					file = await dataToBlob(png);
	
				} else if (type == 'pdf') {
					file = this.$PdfTool.convertBlobToPdf(png)
				}
	
				// Upload
				if (file) {
					let response = await apiUploadService.post({
						files: file
					})
					return response
				}
			}
		},
		init(){
			if (this.bgData) {
				this.refresh = false

				let img = document.createElement('img');
				img.id = 'bgFileId';
				img.src = this.bgData;
				img.style.position = 'absolute'
				img.style.top = '-5000px'

				document.body.appendChild(img);
				let elBg = document.getElementById('bgFileId')
				this.$nextTick(() => {
					setTimeout(() => {
						let drawInpEl = document.getElementById('parent-sign')
						this.option.width = drawInpEl.offsetWidth + 'px';
						this.option.height = (elBg.height * drawInpEl.offsetWidth / elBg.width).toFixed() + 'px'

						// refresh
						this.$nextTick(() => {
							this.refresh = true
						})
					}, 200)
				})
			}
		},
	},

	mounted() {
		eventHub.$on('save-draw-' + this.id, async (data) => {
			let responseImg = await this.save(data.type)
			data.callback(responseImg)
        })

		fetch(this.bg)
		.then(res => res.blob()) 
		.then(blob => {
			let objectURL = URL.createObjectURL(blob);
			this.bgData = objectURL
			this.$nextTick(() => {
				this.$nextTick(() => {
					this.init()
				})
			})
		});

	}
};
</script>



// WEBPACK FOOTER //
// src/components/SavDrawInput.vue